import * as React from 'react'
import { CMSState, Url } from '../../../../cms/blocks/types.gen'
import { Action, IOWidget, mk_widget, async, loadingAsyncState, AsyncState, nothing, mk_pair } from 'widgets-for-react'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { toMonth } from '../../../../cms/blocks/utils.gen'
import { Line } from 'react-chartjs-2'

export type MilkPricesChartBlockProps<customBlockData, extra_images> = {
  block_index: number
  milk_prices: AsyncState<WordPress.MilkPricesResponse>
  kind: 'milk_prices_chart' | 'bio_milk_prices_chart'
}

export function MilkPricesChartBlock<customBlockData, extra_images>(
  props: MilkPricesChartBlockProps<customBlockData, extra_images>,
  options?: { key?: string }
): IOWidget<
  CMSState<customBlockData, extra_images, PublicSite_CustomPageData>,
  Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>
> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: setState => (
        <section className={`block block--milkprices`} key={options && options.key ? options.key : 'text-milkprices'}>
          <div className="block__inner container--xl grid--block">
            {async<WordPress.MilkPricesResponse>(_ => nothing())(props.milk_prices)
              .map(a =>
                setState(s => {
                  let currentBlock = s.blocks.get(props.block_index) as any
                  if (currentBlock.kind === 'milkPricesChartBlock') {
                    currentBlock = {
                      ...currentBlock,
                      value: mk_pair(
                        {
                          ...currentBlock.value.fst,
                          milk_prices: a(props.milk_prices)
                        },
                        currentBlock.value.snd
                      )
                    }
                  }

                  return {
                    ...s,
                    blocks: s.blocks.set(props.block_index, currentBlock)
                  }
                })
              )
              .run(_ => null)}

            {props.milk_prices.kind == 'loaded' && (
              <div className="milkprice">
                <Line
                  ref="chart"
                  options={{tooltips: { mode: 'label' }}}
                  data={milkpricesToChartData(
                    props.kind == 'milk_prices_chart'
                      ? props.milk_prices.value.acf.prices
                      : props.milk_prices.value.acf.bio_prices
                  )}
                />
              </div>
            )}
          </div>
        </section>
      )
    })
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index
}

export function flatMap<T, U>(array: T[], callbackfn: (value: T, index: number, array: T[]) => U[]): U[] {
  return Array.prototype.concat(...array.map(callbackfn))
}

function milkpricesToChartData(prices: Array<WordPress.MilkPrice>) {
  let colors = [
    'rgb(0, 149, 218)',
    'rgb(57, 181, 74)',
    'rgb(237, 28, 36)',
    'rgb(247, 147, 30)',
    'rgb(236, 0, 140)',
    'rgb(215, 223, 35)'
  ]
  return {
    labels: flatMap(prices, year => year.prices_per_month && Array.isArray(year.prices_per_month) ? year.prices_per_month.map(row => row.month) : [])
      .filter(onlyUnique)
      .sort()
      .map(toMonth),
    datasets: prices.map((year, index) => {
      return {
        label: year.year,
        fill: false,
        lineTension: 0.3,
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: colors[index],
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        // pointBorderColor: colors[index],
        pointBackgroundColor: colors[index],
        pointBorderWidth: 0,
        pointHoverRadius: 6,
        pointHoverBackgroundColor: colors[index],
        // pointHoverBorderColor: colors[index],
        pointHoverBorderWidth: 0,
        pointRadius: 4,
        pointHitRadius: 10,
        data: year.prices_per_month && Array.isArray(year.prices_per_month) ? year.prices_per_month
          .sort((a, b) => (a.month < b.month ? -1 : a.month == b.month ? 0 : 1))
          .map(row => row.milk_price) : []
      }
    })
  }
}
